import './accordion.less';

import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'class-autobind';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BaseAccordion from 'zoomforth_component_lib/base_accordion.jsx';
import AccordionItem from './accordion_item.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

import {
  bindTextLinkClickTrackingEvents
} from 'zoomforth_codesbane_viewer/lib/analytics/utils.js';

import {
  setTextLinksToOpenInNewPage
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

class BaseAccordionClass extends Component {
  constructor(props) {
    super(props);
    this.wrapperNodeRef = null;
  }

  componentDidMount() {
    this.doPostRender();
  }
  
  componentDidUpdate() {
    this.doPostRender();
  }
  
  doPostRender() {
    bindTextLinkClickTrackingEvents(this.wrapperNodeRef, '.accordion-text a', 'accordionlinks');
    setTextLinksToOpenInNewPage(this.wrapperNodeRef, '.accordion-text a');
  }
}

class Accordion_ViewerVersion1  extends BaseAccordionClass {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      uuid,
      items,
      defaultOpenItemKeys,
      maxOpenItemsLimit,
      openIndexOverrides,
      onResetOpenIndexOverrides,
      selectedContentItem
    } = this.props;

    return (
      <div
        ref={(ref)=> { this.wrapperNodeRef = ref; }}
        className={classNames(
          'accordion-wrapper', 
          { [`content-uuid-${uuid}`]: uuid }
        )}
      >
        <BaseAccordion 
          className="section-accordion"
          items={items}
          defaultOpenItemKeys={defaultOpenItemKeys}
          maxOpenItemsLimit={maxOpenItemsLimit}
          openIndexOverrides={openIndexOverrides}
          onResetOpenIndexOverrides={onResetOpenIndexOverrides}
          renderItem={({ item, isOpen, onToggleItem }) => (
            <AccordionItem
              uuid={String(item.uuid)}
              label={item.accordion_data && item.accordion_data.label}
              content={item.accordion_data && item.accordion_data.content}
              isOpen={isOpen}
              onLabelLeftClick={onToggleItem}
              onLabelRightClick={onToggleItem}
              isSelected={selectedContentItem && selectedContentItem.uuid === item.uuid}
            />
          )}
        />
      </div>
    );
  }

}

class Accordion_ViewerVersion2  extends BaseAccordionClass {

  constructor(props) {
    super(props);

    this.state = {
      shouldShowAsFocused: false
    };

    autobind(this);
  }

  handleKeyDown(event) {
    // this logic brought to you by:
    // https://www.w3.org/TR/wai-aria-practices-1.1/examples/accordion/js/accordion.js

    var target = event.target;
    var key = event.which.toString();

    const accordion = findDOMNode(this.wrapperNodeRef);

    const triggers = Array.prototype.slice.call(accordion.querySelectorAll('.accordion-item button.accordion-trigger'));

    // 33 = Page Up, 34 = Page Down
    const ctrlModifier = (event.ctrlKey && key.match(/33|34/));

    // Is this coming from an accordion header?
    if (target.classList.contains('accordion-trigger')) {
      // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
      // 38 = Up, 40 = Down
      if (key.match(/38|40/) || ctrlModifier) {
        var index = triggers.indexOf(target);
        var direction = (key.match(/34|40/)) ? 1 : -1;
        var length = triggers.length;
        var newIndex = (index + length + direction) % length;

        triggers[newIndex].focus();

        event.preventDefault();
      } else if (key.match(/35|36/)) {
        // 35 = End, 36 = Home keyboard operations
        switch (key) {
          // Go to first accordion
        case '36':
          triggers[0].focus();
          break;
          // Go to last accordion
        case '35':
          triggers[triggers.length - 1].focus();
          break;
        }

        event.preventDefault();

      }

    }
  }

  handleAccordionItemFocus() {
    this.setState({
      shouldShowAsFocused: true
    });
  }

  handleAccordionItemBlur() {
    this.setState({
      shouldShowAsFocused: false
    });
  }

  render() {
    const {
      uuid,
      items,
      defaultOpenItemKeys,
      maxOpenItemsLimit,
      openIndexOverrides,
      onResetOpenIndexOverrides,
      selectedContentItem
    } = this.props;

    const { shouldShowAsFocused } = this.state;

    return (
      <div
        ref={(ref)=> { this.wrapperNodeRef = ref; }}
        className={classNames(
          'accordion-wrapper', 
          {
            [`content-uuid-${uuid}`]: uuid
          }
        )}
        onKeyDown={this.handleKeyDown}
      >
        <BaseAccordion 
          className={classNames('section-accordion', {
            'is-focused': shouldShowAsFocused
          })}
          items={items}
          defaultOpenItemKeys={defaultOpenItemKeys}
          maxOpenItemsLimit={maxOpenItemsLimit}
          openIndexOverrides={openIndexOverrides}
          onResetOpenIndexOverrides={onResetOpenIndexOverrides}
          renderItem={({ item, isOpen, onToggleItem }) => (
            <AccordionItem
              uuid={String(item.uuid)}
              label={item.accordion_data && item.accordion_data.label}
              content={item.accordion_data && item.accordion_data.content}
              isOpen={isOpen}
              onLabelLeftClick={onToggleItem}
              onLabelRightClick={onToggleItem}
              onFocus={this.handleAccordionItemFocus}
              onBlur={this.handleAccordionItemBlur}
              isSelected={selectedContentItem && selectedContentItem.uuid === item.uuid}
            />
          )}
        />
      </div>
    );
  }

}

const Accordion = (props)=> (
  <SiteViewerVersionComponentSelector>
    <Accordion_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <Accordion_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

Accordion.propTypes = {
  uuid: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  defaultOpenItemKeys: PropTypes.array,
  maxOpenItemsLimit: PropTypes.number,
  selectedContentItem: PropTypes.object
};

export default Accordion;
